// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'lib-auth-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent {

  @Output() usernameSubmitted = new EventEmitter<string>();
  emailFormControl = new FormControl('', [Validators.email, Validators.required]);

  submit(): void {
    if (this.emailFormControl.invalid) {
      return;
    }

    this.usernameSubmitted.emit(this.emailFormControl.value);
  }
}
